import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    console.log('Route changed to:', pathname); // Debug log
    
    const scrollToTop = () => {
      console.log('Attempting to scroll to top...'); // Debug log
      
      // Method 1: Try smooth scrolling
      try {
        window.scrollTo({
          top: 0,
          left: 0,
          behavior: 'smooth'
        });
        console.log('Smooth scroll executed');
      } catch (error) {
        console.log('Smooth scroll failed, trying instant scroll');
        // Method 2: Instant scroll
        window.scrollTo(0, 0);
      }
      
      // Method 3: Also try scrolling the document element
      if (document.documentElement) {
        document.documentElement.scrollTop = 0;
      }
      
      // Method 4: Try scrolling the body
      if (document.body) {
        document.body.scrollTop = 0;
      }

      // Method 5: Scroll the app scroll container (desktop layout)
      const scrollContainer = document.querySelector('.app-scroll-container');
      if (scrollContainer) {
        scrollContainer.scrollTop = 0;
      }
    };

    // Always scroll to top
    scrollToTop();
    
    // Execute after a short delay
    const timeoutId1 = setTimeout(scrollToTop, 50);
    
    // Execute after a longer delay for dynamic content
    const timeoutId2 = setTimeout(scrollToTop, 200);
    
    return () => {
      clearTimeout(timeoutId1);
      clearTimeout(timeoutId2);
    };
  }, [pathname]);

  return null;
}

export default ScrollToTop; 